var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "both-pd-box" },
    [
      _c(
        "div",
        [_c("h3", [_vm._v("客服信息配置")]), _vm._v(" "), _c("el-divider")],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          staticClass: "form-content",
          attrs: { model: _vm.form, "label-width": "110px" },
        },
        [
          _c(
            "div",
            { staticClass: "contact-section" },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "no-label-form-item",
                  attrs: { prop: "wechatVisible" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "section-title" },
                    [
                      _c("img", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-right": "4px",
                        },
                        attrs: {
                          src: require("@/assets/icon_wx.png"),
                          alt: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("微信联系方式")]),
                      _vm._v(" "),
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radio-group",
                          attrs: { size: "small" },
                          model: {
                            value: _vm.form.wechatVisible,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "wechatVisible", $$v)
                            },
                            expression: "form.wechatVisible",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("展示"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("隐藏"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.form.wechatVisible === 1
                ? _c(
                    "div",
                    { staticClass: "section-body" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "填写微信号", prop: "wechatNo" } },
                        [
                          _c("el-input", {
                            staticClass: "form-input",
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.wechatNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "wechatNo", $$v)
                              },
                              expression: "form.wechatNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "二维码图片", prop: "wechatQrUrl" } },
                        [
                          _c("div", { staticClass: "upload-wrapper" }, [
                            _c(
                              "div",
                              { staticClass: "upload-main" },
                              [
                                _vm.form.wechatQrUrl
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "image-box" },
                                        [
                                          _c("el-image", {
                                            staticClass: "avatar",
                                            attrs: {
                                              src: _vm.form.wechatQrUrl,
                                              "preview-src-list": [
                                                _vm.form.wechatQrUrl,
                                              ],
                                              fit: "cover",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "delete-btn",
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                                icon: "el-icon-delete",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.form.wechatQrUrl = ""
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _c(
                                      "el-upload",
                                      {
                                        staticClass: "avatar-uploader",
                                        attrs: {
                                          "show-file-list": false,
                                          action: "",
                                          "http-request":
                                            _vm.handleFileUpload.bind(
                                              null,
                                              "wechatQrUrl"
                                            ),
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-plus avatar-uploader-icon",
                                        }),
                                      ]
                                    ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "upload-tip" }, [
                              _vm._v("建议尺寸200*200px PNG图片"),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contact-section" },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "no-label-form-item",
                  attrs: { prop: "workWechatVisible" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "section-title" },
                    [
                      _c("img", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-right": "4px",
                        },
                        attrs: {
                          src: require("@/assets/icon_qw.png"),
                          alt: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("企业微信联系方式")]),
                      _vm._v(" "),
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radio-group",
                          attrs: { size: "small" },
                          model: {
                            value: _vm.form.workWechatVisible,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "workWechatVisible", $$v)
                            },
                            expression: "form.workWechatVisible",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("展示"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("隐藏"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.form.workWechatVisible === 1
                ? _c(
                    "div",
                    { staticClass: "section-body" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "填写企业微信号",
                            prop: "workWechatNo",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "form-input",
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.workWechatNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "workWechatNo", $$v)
                              },
                              expression: "form.workWechatNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "二维码图片",
                            prop: "workWechatQrUrl",
                          },
                        },
                        [
                          _c("div", { staticClass: "upload-wrapper" }, [
                            _c(
                              "div",
                              { staticClass: "upload-main" },
                              [
                                _vm.form.workWechatQrUrl
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "image-box" },
                                        [
                                          _c("el-image", {
                                            staticClass: "avatar",
                                            attrs: {
                                              src: _vm.form.workWechatQrUrl,
                                              "preview-src-list": [
                                                _vm.form.workWechatQrUrl,
                                              ],
                                              fit: "cover",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "delete-btn",
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                                icon: "el-icon-delete",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.form.workWechatQrUrl = ""
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _c(
                                      "el-upload",
                                      {
                                        staticClass: "avatar-uploader",
                                        attrs: {
                                          "show-file-list": false,
                                          action: "",
                                          "http-request":
                                            _vm.handleFileUpload.bind(
                                              null,
                                              "workWechatQrUrl"
                                            ),
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-plus avatar-uploader-icon",
                                        }),
                                      ]
                                    ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "upload-tip" }, [
                              _vm._v("建议尺寸200*200px PNG图片"),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contact-section" },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "no-label-form-item",
                  attrs: { prop: "qqVisible" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "section-title" },
                    [
                      _c("img", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-right": "4px",
                        },
                        attrs: {
                          src: require("@/assets/icon_QQ.png"),
                          alt: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("QQ联系方式")]),
                      _vm._v(" "),
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radio-group",
                          attrs: { size: "small" },
                          model: {
                            value: _vm.form.qqVisible,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "qqVisible", $$v)
                            },
                            expression: "form.qqVisible",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("展示"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("隐藏"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.form.qqVisible === 1
                ? _c(
                    "div",
                    { staticClass: "section-body" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "填写QQ号", prop: "qqNo" } },
                        [
                          _c("el-input", {
                            staticClass: "form-input",
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.qqNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "qqNo", $$v)
                              },
                              expression: "form.qqNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "二维码图片", prop: "qqQrUrl" } },
                        [
                          _c("div", { staticClass: "upload-wrapper" }, [
                            _c(
                              "div",
                              { staticClass: "upload-main" },
                              [
                                _vm.form.qqQrUrl
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "image-box" },
                                        [
                                          _c("el-image", {
                                            staticClass: "avatar",
                                            attrs: {
                                              src: _vm.form.qqQrUrl,
                                              "preview-src-list": [
                                                _vm.form.qqQrUrl,
                                              ],
                                              fit: "cover",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "delete-btn",
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                                icon: "el-icon-delete",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.form.qqQrUrl = ""
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _c(
                                      "el-upload",
                                      {
                                        staticClass: "avatar-uploader",
                                        attrs: {
                                          "show-file-list": false,
                                          action: "",
                                          "http-request":
                                            _vm.handleFileUpload.bind(
                                              null,
                                              "qqQrUrl"
                                            ),
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-plus avatar-uploader-icon",
                                        }),
                                      ]
                                    ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "upload-tip" }, [
                              _vm._v("建议尺寸200*200px PNG图片"),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "备注信息文案", prop: "remarkText" } },
            [
              _c("el-input", {
                staticClass: "form-textarea",
                attrs: { type: "textarea", rows: 3, placeholder: "请输入" },
                model: {
                  value: _vm.form.remarkText,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remarkText", $$v)
                  },
                  expression: "form.remarkText",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "textarea-tip" }, [
                _vm._v("可填写客服在线时间等信息"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saveLoading },
                  on: { click: _vm.handleSave },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.handleReset } }, [
                _vm._v("重置"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }